import { Component, EventEmitter, ElementRef, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';

import { ApiError, ConfigServerService, JwtService, MessageService, ButtonLoader } from '../../../../core';
import { FileUploader, FileItem, ParsedResponseHeaders } from 'ng2-file-upload';

@Component({
    selector: 'sgt-representante-import-modal',
    templateUrl: './representante-import-modal.component.html',
    styleUrls: ['./representante-import-modal.component.less']
})
export class RepresentanteImportModalComponent implements OnInit {
    @Input() idModal: string;
    elModal: any;
    @Output() afterImport = new EventEmitter<any>();

    @ViewChild('form') form: NgForm;
    @ViewChild('inputFile') inputFile: ElementRef;

    tagImportacao: string;
    error: ApiError;
    fileName: string;
    uploader: FileUploader = new FileUploader({});
    btnImport: ButtonLoader;

    constructor(private el: ElementRef,
                jwtService: JwtService,
                configServerService: ConfigServerService,
                private messageService: MessageService) {
        this.uploader.options.url = `${configServerService.getPathApi()}/import/representante`;
        this.uploader.authToken = jwtService.accessTokenWithBearer;
    }

    ngOnInit() {
        this.create();

        // Ao completear a importação do arquivo
        this.uploader.onCompleteItem = (item: FileItem, response: string, status: number, headers: ParsedResponseHeaders): any => {
            this.btnImport.reset();

            switch (status) {
                case 200: // OK
                    this.clear();
                    this.messageService.success('', 'Importação realizada com sucesso');

                    this.close();
                    this.afterImport.emit();
                    break;
                default: // Demais erros
                    this.error = JSON.parse(response) as ApiError;
                    setTimeout(() => jQuery(this.elModal).find('#messageError').addClass('animated').addClass('shake'), 100);
                    break;
           }
       };

       // Após adicionar o arquivo
       this.uploader.onAfterAddingFile = (fileItem: FileItem): any => {
            fileItem.withCredentials = false;
            this.error = null;
            this.fileName = fileItem.file.name;
       }

        // Antes de iniciar a importação do arquivo
       this.uploader.onBeforeUploadItem = (fileItem: FileItem): any => {
            this.fileName = fileItem.file.name;
       };

       // Ao construir os dados do form no request
       this.uploader.onBuildItemForm = (fileItem: any, form: any) => {
            form.append('tagImportacao', this.tagImportacao);
       }

       // Ao completar a importação
       this.uploader.onCompleteAll = () => {
           this.clearInputFile();
       };
    }

    /** Cria o modal */
    private create() {
        this.elModal = jQuery(this.el.nativeElement).find('.modal') as any;
        this.elModal
            .on('show.bs.modal', (e: any) => {
                e.stopPropagation();
            })
            .on('shown.bs.modal', (e: any) => {
                jQuery(this.elModal).find('#tagImportacao').trigger('focus');
                e.stopPropagation();
            })
            .on('hide.bs.modal', (e: any) => {
                e.stopPropagation();
            })
            .on('hidden.bs.modal', (e: any) => {
                e.stopPropagation();
            });
    }

    /** Limpa os dados da importação */
    private clear() {
        this.error = null;
        this.fileName = null;
        this.clearInputFile();
        jQuery(this.elModal).find('#messageError').removeClass('animated').removeClass('shake');
    }

    /** Limpa o input file de importação */
    private clearInputFile() {
        const el = this.inputFile.nativeElement as HTMLInputElement;
        el.value = '';
    }


    open() {
        this.form.resetForm();
        this.clear();

        this.elModal.modal({keyboard: false});
    }

    close() {
        this.elModal.modal('hide');
    }

    /** Realiza a importação dos representantes através do arquivo selecionado */
    import() {
        this.btnImport = new ButtonLoader('#btnImport');
        this.btnImport.loading('Importando');
        this.uploader.uploadAll();
    }
}
